export function prepareUser(values) {
  return {
    first_name: values.first_name,
    last_name: values.last_name,
    role: values.role,
    username: values.username,
    password: values.password
  };
}
